import { Helmet } from 'react-helmet-async';

import { getDomain } from '../../utils/functions';
import appleTouchIconRuka from './icons/ruka/apple-touch-icon.png';
import appleTouchIconPyha from './icons/pyha/apple-touch-icon.png';
import favicon32Ruka from './icons/ruka/favicon-32x32.png';
import favicon32Pyha from './icons/pyha/favicon-32x32.png';
import favicon16Ruka from './icons/ruka/favicon-16x16.png';
import favicon16Pyha from './icons/pyha/favicon-16x16.png';

// Favicons and other elements that change depending on the domain
// can go here. Title is changed in the page component.
// Static elements can go in public/index.html.
function Head(): JSX.Element {
  let appleTouchIcon = appleTouchIconRuka;
  let favicon32 = favicon32Ruka;
  let favicon16 = favicon16Ruka;
  let themeColor = '#ff1706';
  let title = 'Ruka.fi';

  if (getDomain() === 'pyha') {
    appleTouchIcon = appleTouchIconPyha;
    favicon32 = favicon32Pyha;
    favicon16 = favicon16Pyha;
    themeColor = '#003764';
    title = 'Pyha.fi';
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='theme-color' content={themeColor} />
      <link rel='icon' type='image/png' href={favicon16} sizes='16x16' />
      <link rel='icon' type='image/png' href={favicon32} sizes='32x32' />
      <link rel='apple-touch-icon' href={appleTouchIcon} />
    </Helmet>
  );
}

export default Head;
